import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Paperclip, Github, Globe, Mic, ArrowRight, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

export const ChatInput = ({ placeholder, onSubmit, projectType }) => {
  const { t } = useLanguage();
  const [prompt, setPrompt] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.trim()) {
      onSubmit(prompt);
    }
  };

  return (
    <div className={`chat-input-glow rounded-2xl transition-all duration-300 ${isFocused ? 'glow-orange' : ''}`}>
      <form onSubmit={handleSubmit} className="glass rounded-2xl overflow-hidden">
        {/* Main input area */}
        <div className="p-4 lg:p-6">
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={placeholder}
            rows={3}
            className="w-full bg-transparent text-white text-base lg:text-lg placeholder-gray-500 resize-none focus:outline-none"
            data-testid="chat-input-textarea"
          />
        </div>

        {/* Bottom toolbar */}
        <div className="flex items-center justify-between px-4 lg:px-6 pb-4 lg:pb-6">
          {/* Left side actions */}
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="p-2 rounded-lg hover:bg-white/5 text-gray-400 hover:text-white transition-colors"
              data-testid="chat-attach-btn"
            >
              <Paperclip className="w-5 h-5" />
            </button>
            <button
              type="button"
              className="p-2 rounded-lg hover:bg-white/5 text-gray-400 hover:text-white transition-colors"
              data-testid="chat-github-btn"
            >
              <Github className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 border border-white/10">
              <Sparkles className="w-4 h-4 text-orange-400" />
              <span className="text-sm text-gray-300">Claude 4.5 Sonnet</span>
            </div>
          </div>

          {/* Right side actions */}
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 text-sm text-gray-300 hover:text-white transition-colors"
              data-testid="chat-public-btn"
            >
              <Globe className="w-4 h-4" />
              {t('common.public')}
            </button>
            <button
              type="button"
              className="p-2 rounded-lg bg-amber-500/20 text-amber-400 hover:bg-amber-500/30 transition-colors"
              data-testid="chat-mcp-btn"
            >
              <span className="text-xs font-bold">MCP</span>
            </button>
            <button
              type="button"
              className="p-2 rounded-lg hover:bg-white/5 text-gray-400 hover:text-white transition-colors"
              data-testid="chat-mic-btn"
            >
              <Mic className="w-5 h-5" />
            </button>
            <motion.button
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="p-3 rounded-full bg-gray-700 hover:bg-gray-600 text-white transition-colors"
              data-testid="chat-submit-btn"
            >
              <ArrowRight className="w-5 h-5" />
            </motion.button>
          </div>
        </div>
      </form>
    </div>
  );
};
